import { render, staticRenderFns } from "./customerSupport.vue?vue&type=template&id=721f47d1"
import script from "./customerSupport.vue?vue&type=script&lang=js"
export * from "./customerSupport.vue?vue&type=script&lang=js"
import style0 from "./customerSupport.vue?vue&type=style&index=0&id=721f47d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports